"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LandingPage = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _components2 = require("../components");
var _contexts = require("../contexts");
var _interfaces = require("../interfaces");
var _api = require("../models/api");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  flexGrow: 1,
  height: 'auto',
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingInline: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    paddingInline: theme.spacing(3)
  }
}));
const threeSteps = ['PersonalInfoStep', 'SponsorSelectionStep', 'LegalInformationStep'];
const twoSteps = ['PersonalInfoStep', 'LegalInformationStep'];
const LandingPage = () => {
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData,
    data
  } = notificationData;
  const {
    finished,
    pendingRegistration
  } = (0, _contexts.useRegistrationStatus)();
  const [isVerified, setIsVerified] = (0, _react.useState)(false);
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const feedBackIcon = data?.type === _interfaces.MessageType.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckHeavy, {});
  const {
    registrationType,
    registrationId
  } = (0, _contexts.useConfiguration)();
  const pbs_owner = _jsCookie.default.get('pbs_owner');
  const ecref = _jsCookie.default.get('ecref');
  const handleClose = (0, _react.useCallback)(() => {
    setNotificationData({
      isOpen: false
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [notificationData]);
  const isVipCustomerType = registrationType === 'VipCustomer';
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we want logical operator
  const isCorrectReferral = pbs_owner || ecref;
  const vipWithoutSponsor = isVipCustomerType && !isCorrectReferral;
  const currentSteps = vipWithoutSponsor ? twoSteps : threeSteps;
  const getCorrectContent = () => {
    if (!registrationId) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.PreStep, {});
    }
    if (registrationData?.currentStep === 'ContactVerification' && !isVerified) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.VerificationStep, {
        handleVerifySuccess: () => setIsVerified(true)
      });
    }
    if (pendingRegistration) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.PendingRegistrationStep, {});
    }
    if (finished || registrationData?.currentStep === 'SubmitStep') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.WelcomeStep, {});
    }
    if (registrationData?.registrationId) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.StepperWithContent, {
        currentStep: registrationData.currentStep,
        steps: currentSteps
      });
    }
    return null;
  };
  const correctContent = getCorrectContent();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [registrationId ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.OriflameLogo, {}) : null, correctContent, /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
      open: Boolean(data?.isOpen),
      color: data?.type,
      icon: data?.customIcon ?? feedBackIcon,
      onClose: handleClose,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "data-key": data?.messageId,
        className: "translate",
        children: data?.message
      })
    })]
  });
};
exports.LandingPage = LandingPage;